import { AddProductsToCartMutation } from './AddProductsToCart.gql'

export function toUserErrors(data?: AddProductsToCartMutation | null) {
  return data?.addProductsToCart?.user_errors ?? []
}
